import { withFormik } from "formik";
import SurtyPottencialInsuranceForm from "../Steps/SurtyInsuraceFormStep";
// import SurtyInsuranceForm from "../Steps/SurtyInsuraceFormStep";
import { SurtyPottencialInsuraceinitialValues } from "./initialStatesSurty";

export const SurtyPottencialInsuranceFormik = withFormik<any, typeof SurtyPottencialInsuraceinitialValues>({

  mapPropsToValues: () => SurtyPottencialInsuraceinitialValues,
  handleSubmit: (values, bag) => true,

})(SurtyPottencialInsuranceForm);
